import * as React from "react";

const IconZoomInactive: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fill="currentColor"
                d="M13.68 12.883L10.405 9.61a5.685 5.685 0 00.915-3.957C10.987 3.15 8.935 1.114 6.43.797A5.69 5.69 0 00.047 7.18c.318 2.506 2.354 4.558 4.857 4.892a5.684 5.684 0 003.956-.915l3.273 3.273a1.094 1.094 0 001.546-1.546zM7.873 7.094H6.318v1.532a.651.651 0 01-.631.656.655.655 0 01-.656-.656V7.094H3.475a.65.65 0 01-.632-.656.65.65 0 01.632-.656H5.03V4.25c0-.363.293-.657.631-.657s.656.293.656.657v1.53H7.85a.66.66 0 01.68.657.655.655 0 01-.656.656z"
            />
        </svg>
    );
};

export default React.memo(IconZoomInactive);
